module.exports = __webpack_public_path__ + "static/media/external_env_1_product_image_1.fe84a447.webp";